import axios from "axios";

export const loadSvgAsString = async (url) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };

    const body = {
      path: url,
    };

    const response = await axios.post(process.env.REACT_APP_API_BASE_URL + "/api/get-svg-category", body, {
      headers: headers,
    });
    
    return response.data;
  } catch (error) {
    console.error("Error al realizar la solicitud:", error);
  }
};